export const Paises = {
    BRASIL: 'BRA',
    CHILE: 'CHL',
    COLOMBIA: 'COL',
    COSTA_RICA: 'CRI',
    ECUADOR: 'ECU',
    MEXICO: 'MEX',
};
export const PaisesEnum = {
    BRASIL: 32,
    CHILE: 43,
    COLOMBIA: 47,
    COSTA_RICA: 52,
    ECUADOR: 57,
    MEXICO: 149,
};

export const Subramos = {
    AGRICOLA: 1,
    PECUARIO: 2,
};

export const SubramosEnum = {
    1: "AGRICOLA",
    2: "PECUARIO",
};

export const TipoPersona = {
    MORAL: 'moral',
    FISICA: 'física',
};

export const TipoPersonaEnum = {
    FISICA: 1,
    MORAL: 2,
};

export const EstatusCotizacion = {
    'nueva-solicitud': 'Nueva Solicitud',
    'busqueda-draft': 'Búsqueda de Draft',
    'oferta-comercial': 'Oferta Comercial',
    'carga-documentos': 'Carga Documentos',
    'grado-riesgo': 'Grado Riesgo',
    'alta-predio': 'Alta de Predio',
    'beneficiario-habilitador': 'Beneficiario y Habilitador',
    'finalizada': 'Cotizacion Finalizada',
    'emitida': 'Cotizacion Emitida',
    'rechazada': 'Cotizacion Rechazada',
};

/**
 * Tipos de preguntas de formularios
 */
export const TipoPregunta = {
    Texto: 'text',
    Lista_seleccion: 'omultiple',
    Lista_multiple: 'omultiple2',
    Matriz_seleccion: 'omatriz',
    Matriz_multiple: 'omatriz2',
    Seccion: 'seccion',
    Foto: 'foto',
    Firma: 'firma',
    Titulo: 'title',
    Catalogo: 'cmaster',
};

/**
 * Tipos de ubicación de predio
 */
export const TipoUbicacionPredio = {
    Checkin: 'checkin',
    Checkout: 'checkout',
};

/**
 * Tipos de visitas
 */
export const TipoVisita = {
    AvisoSiniestro: 'Aviso de Siniestro',
    AvisoCosecha: 'Aviso de Cosecha',
    Suscripcion: 'Suscripción',
    SupervicionCredito: 'Supervisión de Crédito',
    Otros: 'Otros',
};

/**
 * Estatus de la orden de trabajo
 */
export const EstatusOrdenTrabajo = {
    Visitada: 'Visitada',
    Asignada: 'Asignada',
    Nuevo: 'Nuevo',
    Pendiente: 'Pendiente',
    Aprobada: 'Aprobada',
    Fondeada: 'Fondeada',
    Creada: 'Creada',
    Rechazada: 'Rechazada',
    Cancelada: 'Cancelada',
    Finalizada: 'Finalizada',
    FinalizadaIncompleta: 'Finalizada-Incompleta',
    EnAprobacionPorCoordinador: 'En Aprobación por Coordinador',
    AprobadaPorCoordinador: 'Aprobada por Coordinador',
    EnAprobacionSubdireccionViaticos: 'En Aprobación Subdirección Viáticos',
    AprobadaPorSubdireccionViaticos: 'Aprobada por Subdireccion Viaticos',
};

export const Estatus = {
    Pendiente: 'Pendiente',
};

export const EstatusInspeccionPlanB = {
    EnProceso: 'En proceso',
    Aprobada: 'Aprobada DO',
    Rechazado: 'Rechazado DO',
};
/**
 * Tipos de solicitud de visita
 */
export const TipoSolicitud = {
    Global: 'Global',
    Individual: 'Individual'
};

export const EstatusSolicitudVisita = {
    Pendiente: 'pendiente',
    Asignada: 'asignada',
    Visitada: 'visitada',
};

/**
 * Tipos de permisos
 */
export const Permisos = {
    EditarFechasOrden: 'editar_fechas_orden',
    DetalleOrden: 'detalle_orden',
    ComprobarViaticos: 'comprobar_viaticos',
    AprobarViaticos: 'aprobar_viaticos',
    DevolucionGasto: 'devolucion_gasto',
    CancelarOrden: 'cancelar_orden',
    AgregarVisitaOrdenesTrabajo: 'agregar_visita_ordenes_trabajo',
    GuardarOrdenesTrabajo: 'guardar_ordenes_trabajo',
    GenerarRutaOrdenesTrabajo: 'generar_ruta_ordenes_trabajo',
    AgregarGastoOrdenesTrabajo: 'agregar_gasto_ordenes_trabajo',
    CoordenadasVisita: 'coordenadas_visita',
    EliminarVisita: 'eliminar_visita',
    EditarEmpresa: 'empresas_edit',
    ActivarEmpresa: 'empresas_activarempresa',
    DesactivarEmpresa: 'empresas_desactivarempresa',
    AlternarGlobalIndividual: 'alternar_global_individual',
    CancelarSolititudVisita: 'cancela_solicitud_visita',
    AprobarOrdenesTrabajo: 'aprobar_orden_trabajo',
    TableroResultadosAprobarRechazarActas: 'tableroresultados_aprobar',
    TableroResultadosEditarFormulario: 'tableroresultados_editarconfomrulario',
    TableroResultadosEliminar: 'tableroresultados_eliminar',
    TableroResultadosExportar: 'tableroresultados_exportar',
    TableroResultadosFormulario: 'tableroresultados_formulario',
    TableroResultadosImpresion: 'tableroresultados_impresion',
    TableroResultadosImpresionPlantilla: 'tableroresultados_impresionplantilla',
    TableroResultadosImprimirCartadeNoAseguramiento: 'tableroresultados_imprimir',
    TableroResultadosObtenJson: 'tableroresultados_obtenjson',
    TableroResultadosVerDetalle: 'tableroresultados_verdetalle',
    ChequesActaAutorizarSiniestros: 'autorizar_siniestros',
    ChequesActaRechazarSiniestros: 'rechazar_siniestros',
    ChequesActaAutorizarAuditoria: 'autorizar_auditoria',
    ChequesActaRechazarAuditoria: 'rechazar_auditoria',
    ChequesActaAutorizarDireccionGeneral: 'autorizar_direccion_general',
    ChequesActaRechazarDireccionGeneral: 'rechazar_direccion_general',
    ChequesActaAutorizarReaseguro: 'autorizar_reaseguro',
    ChequesActaRechazarReaseguro: 'rechazar_reaseguro',
    ChequesActaAutorizarTesoreria: 'autorizar_tesoreria',
    ChequesActaRechazarTesoreria: 'rechazar_tesoreria',
    VisitasSubirImagenes: 'subir_imagenes',
    VisitasVisualizarImagenes: 'visualizar_imagenes',
    AutorizarInspeccionPlanB: 'autorizar_inspeccion_plan_b',
    NuevaInspeccionPlanB: 'nueva_inspeccion_plan_b',
    OrdenTrabajoLiberarFolios: 'liberar_folios_ot',
    OrdenTrabajoLiberarFoliosSiniestros: 'liberar_folios_ot_siniestros'
}
/**
 * Esquemas de aseguramientos subramo Pecuario
 */
export const TipoSeguroEnum = {
    PAGP: "PAGP",
    IAR: "IAR",
    DD: "DD",
    PLANTA: "PLANTA",
    CATP: "CATP",
    CASA: "CASA",
    SEIN: "SEIN",
    AINT: "AINT",
    INV: "INV",
    INVP: "INVP",
    HUR: "HUR",
    PE: "PE",
    PEC: "PEC",
    ACUI: "ACUICOLA",
    RADICACION: "RADICACION",
    RADICACION_COBERTURA_LIMITADA: "RADICACION_COBERTURA_LIMITADA",
    ADAPTACION: "ADAPTACION",
    APICOLA: "APICOLA",
    AVICOLA: "AVICOLA",
    ESTANCIA_TEMPORAL: "ESTANCIA_TEMPORAL",
    ALTA_MORTALIDAD: "ALTA_MORTALIDAD",
    TRANSPORTE: "TRANSPORTE",
    CATASTROFICO_DANOS_PASTIZALES: "CATASTROFICO_DAÑOS_PASTIZALES",
    MEJOR_GENETICO: "MEJOR_GENETICO",
    PECUARIO: "PECUARIO"
};

export const GrupoSeguroPecuarioEnum = {
    UnidadesAsegurar:["ACUICOLA","APICOLA","CATASTROFICO_DAÑOS_PASTIZALES","CASA"],
    MachosHembrasConSinRegistro: ["RADICACION", "ADAPTACION", "ALTA_MORTALIDAD", "TRANSPORTE", "ESTANCIA_TEMPORAL", "MEJOR_GENETICO","RADICACION_COBERTURA_LIMITADA", "PECUARIO"],
    MachosHembrasSinRegistro: ["AVICOLA"]
};

export const Regex = {
    //Genericas
    Email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    CP: /^\d{5}$/,

    //Mexico
    RfcMex: /^([A-ZÑ&]{3,4})\d{6}([A-Z\d]{3})$/,
    CurpMex: /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,

    //Colombia
    RutCol: /^[0-9]{3,10}(-[0-9kK])?$/,
    NitCol: /^[0-9]{3,10}(-[0-9kK])?$/,
    CedulaCol: /^[0-9]{3,10}(-[0-9kK])?$/,
    CP_COL: /^\d{6}$/,

    //Brasil
    CPF_BRA: /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/,
    CNPJ_BRA: /^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/,
    CODIGO_SUSEP: /^(\d{5}\.\d{6}\/\d{4}-\d{2}|\d{20}|\d{9})$/,
    RNE_BRA: /^[A-Z]?\d{7,11}$/,
    CP_BRA: /^\d{5}-?\d{3}$/,

    //Panamá
    RUC_PAN: /^[A-Z0-9.\-\s]{1,25}$/i,
    CCCE_PAN: /^[A-Z0-9-]{1,10}$/i,
    CP_PAN: /^\d{4}$/,

    //Ecuador
    RucEcu: /^\d{13}$/,
    CP_ECU: /^\d{6}$/,

    //Honduras
    RtnHnd: /^\d{1,14}$/, // Registro Tributario Nacional Honduras: solo números, máx. 14 dígitos

    //El Salvador
    NitSlv: /^\d{3,14}$/, // NIT El Salvador: dígitos numéricos (ej. 000000137685)

    // Guatemala - NIT: alfanumérico 1-10 caracteres. CURP/CUI: numérico 3-13 dígitos. Ej: 356987156, 2422264K
    RfcGtm: /^[a-zA-Z0-9-]{1,10}$/,
    CurpGtm: /^\d{3,13}$/,
    CP_GTM: /^\d{5}$/,

};

export const EstatusSolicitudChequeActa = {
    PorAutorizar: 'por-autorizar',
    AutorizadoSiniestros: 'autorizado-siniestros',
    AutorizadoAuditoria: 'autorizado-auditoria',
    AutorizadoDireccionGeneral: 'autorizado-dg',
    AutorizadoReaseguro: 'autorizado-reaseguro',
    AutorizadoTesoreria: 'autorizado-tesoreria',
    RechazadoSiniestros: 'rechazado-siniestros',
    RechazadoAuditoria: 'rechazado-auditoria',
    RechazadoDireccionGeneral: 'rechazado-dg',
    RechazadoReaseguro: 'rechazado-reaseguro',
    RechazadoTesoreria: 'rechazado-tesoreria'
}